import React from 'react';
import { useFilters } from '../../hooks/useFilters';
import { useAuth } from '../../hooks/useAuth';
import { DEFAULT_SEARCH_ADDRESS } from '../../context/FilterContext';
import { getCurrentVisit } from '../../utils/visitCount';

const normalize = (value) => (value || '').trim().replace(/\s+/g, ' ').toLowerCase();

// Beim allerersten Besuch bleibt der Hinweis aus – dann ist ohnehin alles neu.
const MIN_VISITS = 2;

/**
 * AddressHint – einmaliger Hinweis unter der Startadresse auf der Aktivitätenliste.
 *
 * Sichtbar, wenn alle Bedingungen zutreffen:
 *   - mindestens zweiter Besuch (visit_count)
 *   - Gäste: Adresse leer oder gleich der Standardadresse
 *   - Angemeldete: zusätzlich nur, solange keine Wohnadresse im Profil hinterlegt ist
 *
 * Der Hinweis verschwindet von selbst, sobald die Adresse geändert wird – der Zustand
 * ergibt sich allein aus den Filter-/Benutzerdaten, es wird nichts gespeichert.
 */
const AddressHint = () => {
  const { filters } = useFilters();
  const { isAuthenticated, user } = useAuth();

  if (getCurrentVisit() < MIN_VISITS) return null;

  const address = filters.start_address;
  const isDefaultOrEmpty = !address || normalize(address) === normalize(DEFAULT_SEARCH_ADDRESS);
  if (!isDefaultOrEmpty) return null;
  if (isAuthenticated && user?.home_address) return null;

  return (
    <div className="activity-banner-hint body Font-S-B-130-T Colors-Grey-07" role="note">
      {isAuthenticated
        ? 'Gib deinen Startpunkt ein – so siehst du die ÖV-Verbindung ab deiner Haustür.'
        : 'Geben Sie Ihren Startpunkt ein – so sehen Sie die ÖV-Verbindung ab Ihrer Haustür.'}
    </div>
  );
};

export default AddressHint;
